// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3G3Nq","left":"InfoRow_left__1I1Gm"};